import isEmpty from 'lodash/isEmpty';
import uniq from 'lodash/uniq';
import { useMemo } from 'react';

import { useViewerGoogleAnalyticsId } from '../contexts/SiteContext';

const useStoryTrackingVariables = (story, organisation = null) => {
    const viewerGoogleAnalyticsId = useViewerGoogleAnalyticsId();
    const trackingVariables = useMemo(() => {
        const { settings = {} } = story || {};
        const { tracking: orgTracking } = organisation || {};
        const { codes: orgCodes = [] } = orgTracking || {};
        const { tracking: storyTracking } = settings || {};
        const { codes: storyCodes = [] } = storyTracking || {};

        const googleAnalyticsIds = [...(orgCodes || []), ...(storyCodes || [])]
            .filter((storyCode) => {
                const { type, id: trackingId } = storyCode || {};
                return (type === 'ga4') && !isEmpty(trackingId);
            })
            .map(({ id: trackingId }) => trackingId);
        return {
            googleAnalyticsIds: uniq(
                [viewerGoogleAnalyticsId, ...googleAnalyticsIds].filter((it) => it !== null),
            ),
        };
    }, [story, organisation, viewerGoogleAnalyticsId]);
    return trackingVariables;
};

export default useStoryTrackingVariables;
